// src/components/Layout/Footer.js
import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import {
  Box,
  Container,
  Grid,
  Typography,
  Link,
  Divider,
  IconButton,
  Stack
} from '@mui/material'
import { Instagram, Facebook, LinkedIn } from '@mui/icons-material'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  // Cores do rodapé
  const colors = {
    primary: '#333333',
    secondary: '#555555',
    divider: '#E6E8EB'
  }

  return (
    <Box
      component='footer'
      sx={{
        bgcolor: '#F5F6F7',
        pt: 5,
        pb: 3,
        mt: 'auto'
      }}
    >
      <Container maxWidth='xl'>
        <Grid container spacing={4} sx={{ mb: 3 }}>
          {/* Coluna 1 - Logo e descrição */}
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <Box
              component={RouterLink}
              to='/'
              onClick={scrollToTop}
              sx={{
                display: 'flex',
                alignItems: 'center',
                textDecoration: 'none',
                mb: 1
              }}
            >
              <Box
                component='img'
                src='/logo_aux.png'
                alt='Logo'
                sx={{
                  width: 32,
                  height: 32,
                  objectFit: 'contain',
                  mr: 1
                }}
              />
              <Typography
                variant='h6'
                sx={{
                  color: colors.primary,
                  fontWeight: 700,
                  fontSize: '1.5rem',
                  lineHeight: 1
                }}
              >
                umarkt
              </Typography>
            </Box>
            <Typography variant='body2' sx={{ color: colors.secondary, mb: 2 }}>
              Seu imóvel no lugar certo
            </Typography>
            <Typography
              variant='body2'
              sx={{ color: colors.secondary, mb: 3, fontSize: '0.8rem' }}
            >
              Marketplace imobiliário para anunciar e encontrar imóveis no
              Brasil
            </Typography>

            {/* Redes Sociais */}
            <Stack direction='row' spacing={1} sx={{ mb: 2 }}>
              <IconButton
                component='a'
                href='https://instagram.com'
                target='_blank'
                rel='noopener noreferrer'
                size='small'
                sx={{
                  color: colors.secondary,
                  border: `1px solid ${colors.divider}`,
                  '&:hover': {
                    bgcolor: 'primary.main',
                    color: 'white',
                    borderColor: 'primary.main'
                  },
                  transition: 'all 0.3s'
                }}
              >
                <Instagram fontSize='small' />
              </IconButton>
              <IconButton
                component='a'
                href='https://facebook.com'
                target='_blank'
                rel='noopener noreferrer'
                size='small'
                sx={{
                  color: colors.secondary,
                  border: `1px solid ${colors.divider}`,
                  '&:hover': {
                    bgcolor: 'primary.main',
                    color: 'white',
                    borderColor: 'primary.main'
                  },
                  transition: 'all 0.3s'
                }}
              >
                <Facebook fontSize='small' />
              </IconButton>
              <IconButton
                component='a'
                href='https://linkedin.com'
                target='_blank'
                rel='noopener noreferrer'
                size='small'
                sx={{
                  color: colors.secondary,
                  border: `1px solid ${colors.divider}`,
                  '&:hover': {
                    bgcolor: 'primary.main',
                    color: 'white',
                    borderColor: 'primary.main'
                  },
                  transition: 'all 0.3s'
                }}
              >
                <LinkedIn fontSize='small' />
              </IconButton>
            </Stack>

            <Typography
              variant='body2'
              sx={{ color: colors.secondary, fontSize: '0.8rem' }}
            >
              contato@umarkt.com.br
            </Typography>
          </Grid>

          {/* Coluna 2 - Legal */}
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <Typography
              variant='subtitle1'
              sx={{
                fontWeight: 700,
                mb: 2,
                color: colors.primary
              }}
            >
              Legal
            </Typography>
            <Stack spacing={1.5}>
              {/* href normal, nao RouterLink: /faq.html e um arquivo estatico
                  servido pelo nginx, legivel sem JavaScript. E o link interno
                  que faz os buscadores e as IAs encontrarem o FAQ. */}
              <Link
                href='/faq.html'
                sx={{
                  color: colors.secondary,
                  textDecoration: 'none',
                  fontSize: '0.875rem',
                  '&:hover': { color: 'primary.main' }
                }}
              >
                Perguntas frequentes
              </Link>
              <Link
                component={RouterLink}
                to='/termos-de-uso'
                onClick={scrollToTop}
                sx={{
                  color: colors.secondary,
                  textDecoration: 'none',
                  fontSize: '0.875rem',
                  '&:hover': { color: 'primary.main' }
                }}
              >
                Termos de uso
              </Link>
              <Link
                component={RouterLink}
                to='/politica-de-privacidade'
                onClick={scrollToTop}
                sx={{
                  color: colors.secondary,
                  textDecoration: 'none',
                  fontSize: '0.875rem',
                  '&:hover': { color: 'primary.main' }
                }}
              >
                Política de privacidade e segurança
              </Link>
            </Stack>
          </Grid>

          {/* Coluna 3 - Profissionais */}
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <Typography
              variant='subtitle1'
              sx={{
                fontWeight: 700,
                mb: 2,
                color: colors.primary
              }}
            >
              Profissionais
            </Typography>
            <Stack spacing={1.5}>
              <Link
                component={RouterLink}
                to='/para-profissionais'
                onClick={scrollToTop}
                sx={{
                  color: colors.secondary,
                  textDecoration: 'none',
                  fontSize: '0.875rem',
                  '&:hover': { color: 'primary.main' }
                }}
              >
                Para corretores e imobiliárias
              </Link>
            </Stack>
          </Grid>

          {/* Coluna 4 - Imóveis em Chapecó */}
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <Typography
              variant='subtitle1'
              sx={{
                fontWeight: 700,
                mb: 2,
                color: colors.primary
              }}
            >
              Imóveis em Chapecó
            </Typography>
            <Stack spacing={1.5}>
              <Link
                component={RouterLink}
                to='/chapeco/comprar-imovel'
                onClick={scrollToTop}
                sx={{
                  color: colors.secondary,
                  textDecoration: 'none',
                  fontSize: '0.875rem',
                  '&:hover': { color: 'primary.main' }
                }}
              >
                Comprar imóvel em Chapecó
              </Link>
              <Link
                component={RouterLink}
                to='/chapeco/casas-a-venda'
                onClick={scrollToTop}
                sx={{
                  color: colors.secondary,
                  textDecoration: 'none',
                  fontSize: '0.875rem',
                  '&:hover': { color: 'primary.main' }
                }}
              >
                Casas à venda em Chapecó
              </Link>
              <Link
                component={RouterLink}
                to='/chapeco/apartamentos-a-venda'
                onClick={scrollToTop}
                sx={{
                  color: colors.secondary,
                  textDecoration: 'none',
                  fontSize: '0.875rem',
                  '&:hover': { color: 'primary.main' }
                }}
              >
                Apartamentos à venda em Chapecó
              </Link>
              <Link
                component={RouterLink}
                to='/chapeco/terrenos-a-venda'
                onClick={scrollToTop}
                sx={{
                  color: colors.secondary,
                  textDecoration: 'none',
                  fontSize: '0.875rem',
                  '&:hover': { color: 'primary.main' }
                }}
              >
                Terrenos à venda em Chapecó
              </Link>
            </Stack>
          </Grid>
        </Grid>

        <Divider sx={{ borderColor: colors.divider, my: 2 }} />

        {/* Copyright */}
        <Typography
          variant='body2'
          sx={{ color: colors.secondary, fontSize: '0.8rem' }}
        >
          © {currentYear} UMARKT — Todos os direitos reservados.
        </Typography>
      </Container>
    </Box>
  )
}

export default Footer
